<template>
  <game-form
    mode="create"
    @submit="handleSubmit"
  />
</template>

<script>
  import { GameForm } from '../../components'
  import { useCreateGame } from './gameHooks'

  export default {
    name: 'AddGame',
    components: { GameForm },
    mixins: [
      useCreateGame('handleSubmit')
    ]
  }
</script>

<style scoped>

</style>
